import { Box, Image, Checkbox } from '@chakra-ui/react'
import React, { useState, useEffect } from 'react'
import H4 from '../../Theme/Typography/H4';
import { getImageURL } from '../../util/getImage';

//S3 Bucket osw-dev-images
const IMAGE_BASE_PATH = process.env.REACT_APP_DEV_IMAGE_BASE_PATH;

const placeholderImg = `${IMAGE_BASE_PATH}/ui/DummyImage/small.png`

export default function ArchiveGrid({
  data,
  handleDrawer,
  border,
  alignLeft,
  enableCheckbox = false,
  handleCheckboxChange
}) {
  const [checkedItems, setCheckedItems] = useState({});

  // Initialize checkedItems based on highlight value
  useEffect(() => {
    if (data && Array.isArray(data)) {
      const initialCheckedItems = {};
      data.forEach((item, index) => {
        // Check if item has highlight key with value array length > 0
        if (item.highlight && Array.isArray(item?.highlight) && item?.highlight.length > 0) {
          initialCheckedItems[index] = true;
        }
      });
      setCheckedItems(initialCheckedItems);
    }
  }, [data]);

  const handleCheckboxClick = (item, index, isChecked) => {
    setCheckedItems(prev => ({
      ...prev,
      [index]: isChecked
    }));
    if (handleCheckboxChange) {
      handleCheckboxChange(item, isChecked);
    }
  };

  return (
    <>{data?.map((item, index) => (
      <Box key={index}>
        <Box height="auto" position="relative">
          {item.link ? (
            <Box
              justifyItems="center"
              display="flex"
              height={"270px"}
              bg="white"
              justifyContent="space-around"
              position="relative"
            >
              {enableCheckbox && (
                <Checkbox
                  position="absolute"
                  top="8px"
                  right="8px"
                  zIndex={10}
                  bg="white"
                  borderRadius="4px"
                  size="lg"
                  borderColor="#000000"
                  borderWidth="1px"
                  isChecked={checkedItems[index] || false}
                  onChange={(e) => handleCheckboxClick(item, index, e.target.checked)}
                  onClick={(e) => e.stopPropagation()}
                  _checked={{
                    bg: "blue.500",
                    borderColor: "#000000",
                    color: "white"
                  }}
                  _hover={{
                    borderColor: "#000000"
                  }}
                />
              )}
              <Image
               fallbackSrc={placeholderImg}
                src={getImageURL(item?.imagePath ? item?.imagePath : item?.image, 265, 270)}
                alt=""
                cursor={"pointer"}
                transition="1s ease"
                width={"auto"}
                objectFit={"contain"}
                onClick={() =>
                  handleDrawer(item)
                }
                _hover={{ transform: "scale(1.1)" }}
              />
            </Box>
          ) : (
            <Box
              justifyItems="center"
              display="flex"
              height={{base:"185px",md:"270px"}}
              bg="white"
              justifyContent="space-around"
              position="relative"
            >
              {enableCheckbox && (
                <Checkbox
                  position="absolute"
                  top="8px"
                  right="8px"
                  zIndex={10}
                  bg="white"
                  borderRadius="4px"
                  size="lg"
                  borderColor="#000000"
                  borderWidth="2px"
                  isChecked={checkedItems[index] || false}
                  onChange={(e) => handleCheckboxClick(item, index, e.target.checked)}
                  onClick={(e) => e.stopPropagation()}
                  _checked={{
                    bg: "blue.500",
                    borderColor: "#000000",
                    color: "white"
                  }}
                  _hover={{
                    borderColor: "#000000"
                  }}
                />
              )}
              <Image
                src={getImageURL(item?.imagePath ? item?.imagePath : item?.image, 265, 270)}
                alt=""
                fallbackSrc={placeholderImg}
                cursor={"pointer"}
                transition="1s ease"
                width={"auto"}
                objectFit={"contain"}
                onClick={() =>
                  handleDrawer(item)
                }
              />
            </Box>
          )}
         <H4
            fontSize={{base:"14px",md:"16px"}}
            lineHeight={"18.78px"}
            textAlign={{ base: "left", md: "left" }}
            color="color.blue"
            py="2"
            cursor={"pointer"}
            style={{
              display: '-webkit-box',
              overflow: 'hidden',
              WebkitBoxOrient: 'vertical',
              WebkitLineClamp: 3,
              height:"65px"
            }}
            onClick={() =>
              handleDrawer(item)
            }
          >
            {/* {!item.desc && <>
              {item?.creator && item?.creator.creator && (
                <>{` ${item?.creator.creator.lastname}, `}</>
              )}

              {item?.creator && item?.creator.creator && (
                <>
                  {` ${item?.creator.creator.firstname}`}
                  {item?.creator.creator.lastname !== "" && ` | `}
                </>
              )}

              {item?.sortable_year_date_of_publication &&
                item?.creator.creator &&
                item?.creator.creator.lastname === "" ? (
                <>{` (Ed). (${item?.sortable_year_date_of_publication}), `}</>
              ) : (
                <>{`${item?.sortable_year_date_of_publication}. `}</>
              )}
              {item?.creator &&
                item?.creator.creator &&
                item?.creator.creator.lastname === "" && (
                  <>{`Art Heritage Annual. ${item?.location}:${item?.gallery}. `}</>
                )}
              {item?.document_type &&
                item?.document_type &&
                item?.creator.creator &&
                item?.creator.creator.lastname !== "" && (
                <>{`BOOK.${item?.document_type} `}</>
              )}
            </>} */}
            {
              item.desc ? item.desc :''
            }
          </H4>
        </Box>
      </Box>))}
    </>
  )
}

